import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
export interface IConfigurableError {
    shouldShow: boolean;
    attribute?: string;
}
@Injectable({
    providedIn: 'root'
})
export class ConfigurableOptionsErrorService {
    error = new BehaviorSubject<IConfigurableError>({ shouldShow: false, attribute: undefined });
}
